import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2768ce2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_2 = {
  key: 0,
  class: "backup-textarea content-revealed",
  "data-testid": "displayDeveloperKeys"
}
const _hoisted_3 = { class: "description mb-4" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = {
  key: 1,
  class: "content"
}
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "buttons larger-action-button mt-6" }

import { useI18n } from 'vue-i18n'
import { ref, onMounted } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import {
  Password,
  Error as ErrorComponent,
  Textarea,
} from '@/popup/components/shared/Form/Form'
import { InternalMethods } from '@/shared/apis/messages'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InputError } from '@/popup/components/shared/Form/FormTypes'
import ClipboardButton from '../shared/ClipboardCopy/ClipboardButton.vue'
import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayAccount',
  props: {
    onCancel: { type: Function, default: () => ({}) }
  },
  setup(__props: any) {

const properties = __props

const password = ref('')
const privateKeyReport = ref<string>()
const downloaded = ref(false)
const errors = ref<InputError[]>([])
const focus = ref(false)
const { t } = useI18n({ useScope: 'global' })
const appStore = useAppStore()

const revealPrivateKey = async () => {
  if (!password.value) {
    return
  }
  try {
    const privateKey = await useGlobals().sendMessage({
      method: InternalMethods.REVEAL_PRIVATE_KEY,
      payload: {
        controllerAddress: appStore.upExtensionControllerAddress!,
        password: password.value,
      },
    })
    privateKeyReport.value = privateKey
  } catch (error) {
    if (error instanceof Error) {
      errors.value[0] = error.message
    } else if (typeof error === 'string') {
      errors.value[0] = error
    } else {
      errors.value[0] = t('backend.unlock.incorrect_password')
    }
  }
}

const onCancel = () => {
  privateKeyReport.value = undefined
  password.value = ''
  errors.value[0] = ''
  properties.onCancel()
}

onMounted(() => {
  focus.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "extra-class": "wider" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: onCancel
      }),
      _createVNode(_unref(Modal).Content, {
        "extra-class": "wider higher",
        onClick: () => false
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, { "extra-class": "larger" }, {
            default: _withCtx(() => [
              (downloaded.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createVNode(SvgIcon, {
                      height: "24",
                      width: "24",
                      name: "complete",
                      color: `var(--green-54)`
                    }, null, 8 /* PROPS */, ["color"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('modal.developer.title')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          (privateKeyReport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modal.developer.description')), 1 /* TEXT */),
                _createVNode(_unref(Textarea), {
                  readonly: "",
                  value: privateKeyReport.value
                }, null, 8 /* PROPS */, ["value"]),
                _createElementVNode("div", _hoisted_4, [
                  (privateKeyReport.value != undefined)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        variant: "text",
                        class: "mt-3",
                        onClick: onCancel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('modal.developer.close')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _withDirectives(_createVNode(ClipboardButton, {
                    value: privateKeyReport.value,
                    "copy-text": _ctx.$t('modal.developer.copy_to_clipboard'),
                    "copied-text": _ctx.$t('modal.developer.copied_to_clipboard'),
                    class: "mt-3"
                  }, null, 8 /* PROPS */, ["value", "copy-text", "copied-text"]), [
                    [_vShow, privateKeyReport.value != undefined]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("form", {
                  class: "password-form",
                  onSubmit: _withModifiers(revealPrivateKey, ["prevent"])
                }, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('modal.developer.password_description')), 1 /* TEXT */),
                  _createVNode(_unref(Password), {
                    password: password.value,
                    "onUpdate:password": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                    errors: errors.value,
                    "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((errors).value = $event)),
                    "show-info": false,
                    autofocus: focus.value,
                    validators: [],
                    "is-bordered": true
                  }, null, 8 /* PROPS */, ["password", "errors", "autofocus"]),
                  (errors.value?.length)
                    ? (_openBlock(), _createBlock(_unref(ErrorComponent), {
                        key: 0,
                        error: errors.value[0]
                      }, null, 8 /* PROPS */, ["error"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Button, {
                      variant: "text",
                      type: "button",
                      onClick: onCancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(Button, {
                      class: "submit",
                      variant: "primary",
                      "is-full-width": true,
                      disabled: !password.value,
                      "data-testid": "modal-reveal-button",
                      type: "submit",
                      onClick: revealPrivateKey
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('settings.developer.password.button_title')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})